"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CfgUsrPlayerTagEditor_1 = require("./component/CfgUsrPlayerTagEditor");
var CfgUsrPlayerTagsList_1 = require("./component/CfgUsrPlayerTagsList");
var PCfgUsrPlayerTagsList = /** @class */ (function (_super) {
    __extends(PCfgUsrPlayerTagsList, _super);
    function PCfgUsrPlayerTagsList(props) {
        return _super.call(this, props) || this;
    }
    PCfgUsrPlayerTagsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_TT = this.props.tagTypesData.Subscribe("*", function (id, data) {
            _this.setState({
                avail_tagtypes: data.data
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            avail_tagtypes: [],
            page_num: 1,
            page_size: this.props.state.getTablePageSize()
        }, function () {
            _this.props.tagTypesData.LoadData();
        });
    };
    PCfgUsrPlayerTagsList.prototype.componentWillUnmount = function () {
        this.props.tagTypesData.UnSubscribe(this.SID_TT);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCfgUsrPlayerTagsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCfgUsrPlayerTagsList.prototype.onEditClick = function (id) {
        this.setState({ edit_mode: "EDIT", record: id });
    };
    PCfgUsrPlayerTagsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCfgUsrPlayerTagsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCfgUsrPlayerTagsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CfgUsrPlayerTagEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), availTagTypes: this.state.avail_tagtypes }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CfgUsrPlayerTagEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), availTagTypes: this.state.avail_tagtypes }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CfgUsrPlayerTagsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCfgUsrPlayerTagsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCfgUsrPlayerTagsList.getPageDescription = function (state) {
        return {
            icon: "user-tag",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_config_usr_players_tags + "-id",
            itemTitle: "Метки",
            route: routes_1.routes.page_config_usr_players_tags,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCfgUsrPlayerTagsList;
}(React.Component));
exports.default = PCfgUsrPlayerTagsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_player_tags/ui/PCfgUsrPlayerTagsList.tsx
// module id = 2166
// module chunks = 0